// Interruptor liga/desliga (DA-398). Nasceu do "Ativo" do cadastro de usuario: checkbox perdido no
// meio de outros checkboxes nao transmitia que ali se decide se a pessoa ENTRA no sistema — e o
// Ruan pediu um toggle. Peca compartilhada de proposito: o proximo campo que ligar/desligar algo
// (nao "marcar uma opcao entre varias") reusa, nao redesenha.
//
// - O ESTADO VEM ESCRITO ao lado, nao so na cor: o Ruan nao distingue verde/vermelho
//   (`user_daltonismo`), e cor sozinha nunca e o unico sinal. Ligado = cor da marca; desligado = cinza.
// - Entra na ordem de Tab sozinho e AGE como o nativo que imita — Espaco/Enter alternam,
//   `role="switch"` + `aria-checked` pro leitor de tela, foco visivel (DA-304/DA-305).
interface InterruptorProps {
  ligado: boolean;
  onChange: (ligado: boolean) => void;
  /** Texto exibido quando ligado (ex.: "Ativo"). */
  rotuloLigado: string;
  /** Texto exibido quando desligado (ex.: "Inativo"). */
  rotuloDesligado: string;
  /** Linha miuda embaixo, explicando o efeito do estado ATUAL. */
  ajuda?: string;
  desabilitado?: boolean;
}

export function Interruptor({ ligado, onChange, rotuloLigado, rotuloDesligado, ajuda, desabilitado }: InterruptorProps) {
  return (
    <div className="interruptor-campo">
      <button
        type="button"
        role="switch"
        aria-checked={ligado}
        aria-label={ligado ? rotuloLigado : rotuloDesligado}
        disabled={desabilitado}
        onClick={() => onChange(!ligado)}
        className={`interruptor${ligado ? ' interruptor--ligado' : ''}`}
      >
        <span className="interruptor-bolinha" />
      </button>
      <span className={`interruptor-rotulo${ligado ? ' interruptor-rotulo--ligado' : ''}`}>
        {ligado ? rotuloLigado : rotuloDesligado}
      </span>
      {ajuda && <span className="interruptor-ajuda">{ajuda}</span>}
    </div>
  );
}
